export const iconFontAwesomeAlphabetX = (
	<i className="fa-solid fa-x"></i>
);
